(ns frontend.ui.component.lp-portal.report.body.sparkmind.holding.pdf
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view :as overview-figures-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer
    [empty-table-data?]]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :refer [card]]))

(defn company-page
  [data]
  (let [{:keys [holding-name overview business-and-general-kpi current-key-impact-indicators]}
        data]
    (page/page
     (page/third-column-background-full-height-not-rounded)
     (page/page-title-with-line {:fund-name  (:fund-name data)
                                 :page-title
                                 holding-name
                                 :toc-item   true})
     (column/columns-2-to-1
      (card
       ""
       (text-content/rich-content (->> overview
                                       :case-overview
                                       :rich-content))
       (column/columns
        (card ""
              (vertical-table-pdf/table business-and-general-kpi)
              (text-content/optional-footer business-and-general-kpi))
        (card ""
              (vertical-table-pdf/table current-key-impact-indicators)
              (text-content/optional-footer current-key-impact-indicators))))
      (card
       nil
       (block-table-pdf/table (->> overview
                                   :general-information))
       (text-content/optional-footer (:general-information overview)))))))

(defn holding-pages
  [data]
  (let []
    (when-not (cu/blank-value? (:reference-date data))
      (concat [(company-page data)]))))
